import { ActivityEntityName, JobTemplateCode } from '@jms/model';
import { itemFamilyBoard } from '@workbuddy/entities/work.job.item/job.item.manifest';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';
import { ITEM_BROWSER_DIALOG_PRESENTATION } from '@workbuddy/ui/blocks/line.items';

/**
 * The same `jobtemplates` documents as Job Template at its own metadata chain, so the items board
 * inherits none of its columns, filters or grouping. No `edit` operation: a template item has no
 * execution state to inspect, so the inline row editor is the whole edit surface.
 *
 * Board and editor use the embedded-item base below.
 */
export const jobTemplateItemManifest = registerManifest<JobTemplateCode>({
  entity: ActivityEntityName.JobTemplateItem,
  slug: 'job-template-item',

  operations: {

    // Custom dialog: multi-select catalogue → AddItems.
    create: {
      kind: 'custom',

      // Shared shell; this entity's wording and write arrive as params.itemBrowser.
      load: () => import('@workbuddy/entities/shared/item.browser.dialog').then(m => m.ItemBrowserDialogComponent),
      presentation: {
        mode: 'dialog',
        ...ITEM_BROWSER_DIALOG_PRESENTATION,
      },
    },
  },

  board: itemFamilyBoard,
});
